import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Houston.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol as your Mobile App Development Partner in
              Houston?
            </h2>
            <p>
              Start your digital transformation with TekRevol, where innovation
              matches with local intelligence, creating custom solutions for
              your success. We deliver top-tier apps to our clients, which is
              the recognized standard of the industry. Based in the city of
              Houston for a regional edge, we promise to provide exceptional app
              development services irrespective of client’s requirements. Relish
              our customized solutions that are aligned with your vision,
              leveraging trailblazing technology for future-ready applications.
              Our agile approach guarantees flexibility and swift results,
              perfected by affordable high-quality solutions. Take full
              advantage of transparent communication, endless support, and
              creative ideas that make your app shine. Partner with us for an
              unrivaled era of mobile application excellence, where innovation
              knows no limits!
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
